// @flow

import React from 'react'
import SvgIcon from './SvgIcon'
import LockSvg from 'material-design-icons/action/svg/production/ic_lock_outline_24px.svg'

// Types
type Props = {
  size?: number,
  color?: string,
  style?: Object,
}

export function Lock ({size = 24, color = 'rgb(0, 0, 0)', style = {}}: Props): React.Element<any> {
  return (
    <SvgIcon size={size} color={color} src={LockSvg} style={style} />
  )
}

export default Lock
